/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/require-default-props */
/* eslint-disable prefer-arrow-callback */
import {
  Box, Button, FormControlLabel, FormGroup, Stack, Typography,
} from '@mui/material';
import { add, format, getMonth } from 'date-fns';
import { styled } from '@mui/system';
import CustomCalendarVex from '@/components/CustomCalendarVex';
import { pr } from '@/utils/pxToRem';
import { style } from '@/styles/globals';
import IOSSwitch from '@/components/IosSwitch';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '@/utils/hook';
import {
  TMinFareObj,
  useLazyGetFlightStatistics2Query,
} from '@/slices/flightData/apis/flightDataApi';
import { getAreaPointArr } from '@/utils';
import { monthYears } from '@/utils/monthYears';
import { TGenerateFlightCountRequest } from '@/utils/generateFlightRequest';
import { setShowCalendarVietNam } from '@/slices/calendar/calendarSlice';
import Image from '@/containers/SearchFlightTabVcms/Image';
import { uniqueId } from 'lodash';

const StyledGridContainer = styled('div')`
  display: block;
  margin-top: 12px;
  margin-bottom: 10px;
`;

const StyledContainer = styled('div')({
  textAlign: 'center',
  backgroundColor: 'white',
  zIndex: 1,
  width: '100%',
  marginBottom: pr`16px`,
  marginTop: pr`16px`,
});
const leftIcon = 'https://storage.googleapis.com/goyolo-uat/images/SeoVexImprove/left.svg';
const rightIcon = 'https://storage.googleapis.com/goyolo-uat/images/SeoVexImprove/right.svg';

const CalendarFareInMonthVcms = ({
  dayPriceObj: none,
  selectedDate,
  month,
  onSearchFlight,
  lang,
  countResult,
}: any) => {
  const [currIdx, setCurrIdx] = useState(0);
  const diffMonthToNow = month || getMonth(new Date()) - getMonth(new Date());
  const dataList = Array(6).fill({});
  const isShowCalendarVietNam = useAppSelector(
    (state) => state.calendar.showCalendarVietNam,
  );
  const dispatch = useAppDispatch();
  const { startPointHome, toPointHome } = useAppSelector(
    (state) => state.searchFlightForm,
  );
  const [getMinFare, { isLoading, data: staticData }] = useLazyGetFlightStatistics2Query();
  const flightRequest: TGenerateFlightCountRequest = {
    from: startPointHome ? getAreaPointArr(startPointHome) : [],
    to: toPointHome ? getAreaPointArr(toPointHome) : [],
    month_years: monthYears(),
    flight_class: 'PT',
    // disable_update_filter: 1,
  };
  const data = staticData || countResult;
  const dayPriceObj = {} as TMinFareObj;
  data?.forEach((group: any) => {
    Object.keys(group?.grouped_by_date).forEach((groupedDate) => {
      dayPriceObj[groupedDate] = group?.grouped_by_date[groupedDate].min_fare;
    });
  });

  // useEffect(() => {
  //   if (startPointHome && toPointHome) {
  //     getMinFare(flightRequest);
  //   }
  // }, [startPointHome, toPointHome]);
  const updateCurrIdx = (type: string) => {
    if (type === 'pre' && currIdx > 0) {
      setCurrIdx(currIdx - 1);
    }
    if (type === 'next' && dataList?.length - 2 > currIdx) {
      setCurrIdx(currIdx + 1);
    }
  };
  const renderDay = (dayArr = ['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN']) => {
    const DayComponent = dayArr.map((day) => {
      const isWeekend = /T7|CN/i.test(day);
      return (
        <Typography
          variant="subtitle2"
          key={uniqueId()}
          color={style.neutral.gray}
        >
          {day}
        </Typography>
      );
    });
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-around',
        }}
      >
        {DayComponent}
      </div>
    );
  };
  return (
    <Box
      sx={{
        width: 'calc(100% + 16px)',
        background: '#FFFFFF',
        /* Popup-Section Shadow */
        ml: '-8px',
        mt: pr`8px`,
        // height: '511px',
        boxShadow: '0px 2px 10px rgba(7, 65, 57, 0.15)',
        borderRadius: '12px',
        // overflow: 'scroll',
      }}
    >
      {dataList.map((_, idx) => {
        if (idx !== currIdx) {
          return <></>;
        }
        const nextMonth = add(new Date(), { months: idx + diffMonthToNow });
        const monthString = nextMonth.getMonth() + 1;
        const GroupTitleBar = () => (
          <StyledContainer>
            {/* {idx === 0 && ( */}
            {/* <FormGroup
              style={{
                display: 'block',
                textAlign: 'end',
                marginTop: '14px',
              }}
            >
              <FormControlLabel
                style={{
                  justifyContent: 'flex-end',
                }}
                componentsProps={{
                  typography: {
                    fontSize: '14px',
                    fontWeight: 500,
                  },
                }}
                control={(
                  <IOSSwitch
                    size="small"
                    color="secondary"
                    defaultChecked={isShowCalendarVietNam}
                    checked={isShowCalendarVietNam}
                  />
                )}
                label={(
                  <Typography
                    sx={{ ml: pr`4px` }}
                    variant="body2"
                  >
                    {lang?.global?.displayLunarCalendar || 'Hiển thị lịch âm'}
                  </Typography>
                )}
                defaultChecked={isShowCalendarVietNam}
                onChange={(value: any) => dispatch(
                  setShowCalendarVietNam({ value: value?.target?.checked }),
                )}
              />
            </FormGroup> */}
            <Stack
              sx={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '16px 22px',
                mt: '16px',
              }}
            >
              <Box
                onClick={() => updateCurrIdx('pre')}
              >
                <Image
                  imageSrc={leftIcon}
                  alt="pickup-icon"
                  className="pickup-icon"
                  imageProps={{
                    width: 24,
                    height: 24,
                  }}
                />
              </Box>

              <Typography
                variant="body1"
                fontWeight="700"
                color={style.neutral.dark}
                sx={{
                  fontSize: '20px',
                  lineHeight: '28px',
                }}
              >
                {/* {`${lang?.global?.month || 'Tháng'} ${monthString}, ${nextMonth.getFullYear()}`} */}
                {lang?.lang === 'en'
                  ? format(
                    new Date(
                      nextMonth.getFullYear(),
                      nextMonth.getMonth(),
                      1,
                    ),
                    'MMMM yyyy',
                  )
                  : `Tháng ${monthString}, ${nextMonth.getFullYear()}`}
              </Typography>
              <Box
                onClick={() => updateCurrIdx('next')}

              >
                <Image
                  imageSrc={rightIcon}
                  alt="pickup-icon"
                  className="pickup-icon"
                  imageProps={{
                    width: 24,
                    height: 24,
                  }}
                />
              </Box>

            </Stack>
            <StyledGridContainer>{renderDay(lang?.global?.dayOfWeek)}</StyledGridContainer>

          </StyledContainer>
        );

        return (
          <div
            key={idx.toString()}
            style={{
              borderRadius: '4px',
              marginTop: 16,
            }}
          >
            <GroupTitleBar />
            <CustomCalendarVex
              showCalendarLunar={isShowCalendarVietNam}
              highlightToday={idx === 0}
              monthAdded={idx + diffMonthToNow}
              dayPriceObj={dayPriceObj}
              selectedDate={selectedDate}
              setSelectedDate={onSearchFlight}
              isVcms
              seo
            />
          </div>
        );
      })}
      <Button
        onClick={() => dispatch(
          setShowCalendarVietNam({ value: !isShowCalendarVietNam }),
        )}
        sx={{
          padding: '6px 19px',
          gap: '10px',
          // width: '85px',
          height: '32px',
          /* Primary/Blue */
          background: '#2474E5',
          /* Neutral/Border */
          border: '1px solid #E0E0E0',
          borderRadius: '4px',
          color: '#FFFFFF',
          fontWeight: 400,
          fontSize: '14px',
          lineHeight: '20px',
          marginTop: '29px',
          marginLeft: '16px',
          marginBottom: '16px',
          ':hover': {
            bgcolor: '#2474E5',
          },
        }}
      >
        {lang?.global?.displayLunarCalendar1 || 'Âm lịch'}
      </Button>
    </Box>
  );
};

export default CalendarFareInMonthVcms;
